import styled from "styled-components"
import MotibellDetail from "components/modules/motibell/MotibellDetail"
import TitleHeader from "components/presenters/header/TitleHeader"

export default function MotibellDetailLayout() {
  return (
    <PageWrapper>
      <HeaderWrapper>
        <TitleHeader title={"도전 모티벨"} isNotiBtn={true} />
      </HeaderWrapper>
      <BodyWrapper>
        <MotibellDetail />
      </BodyWrapper>
    </PageWrapper>
  )
}

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`

const HeaderWrapper = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (59.68 / 375));
  height: calc(100vw * (60 / 375));
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow-y: scroll;
`
